import {
  FETCH_SESSIONS_FAIL,
  FETCH_SESSIONS_SUCCESS,
  GET_SESSIONS_SUCCESS,
  GET_SESSIONS_FAIL,
} from '../actions/sessions';

const initState = {
  error: '',
  items: [],
  selectedDate: new Date(),
  success: '',
};

export default (state = {}, action) => {
  const newState = { ...initState, ...state };
  switch (action.type) {
    case FETCH_SESSIONS_FAIL:
      return { ...newState, success: '', error: action.error };
    case FETCH_SESSIONS_SUCCESS:
      return { ...newState, success: action.message, error: '' };
    case GET_SESSIONS_SUCCESS:
      return { ...newState, items: action.items || [], error: '', selectedDate: action.date };
    case GET_SESSIONS_FAIL:
      return { ...newState, error: action.error };
    default:
      return newState;
  }
};
